module.exports = __webpack_public_path__ + "img/jy.b72a93da.png";